export class HierarchyAttributesServiceConstants {
    public static activateAction = 'activate';
    public static deactivateAction = 'deactivate';
}
